'use client';

import * as React from 'react';
import { motion } from 'motion/react';
import { cn } from '@/lib/utils';

export const FlipText = ({
  frontText,
  backText,
  className,
  frontClassName,
  backClassName,
}) => {
  return (
    <div className={cn("relative block overflow-hidden", className)}>
      <motion.span
        variants={{
          initial: { y: "0%" },
          hover: { y: "-100%" },
        }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        className={cn("block", frontClassName)}
      >
        {frontText}
      </motion.span>
      <motion.span
        variants={{
          initial: { y: "100%" },
          hover: { y: "0%" },
        }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        className={cn("absolute inset-0 block", backClassName)}
      >
        {backText}
      </motion.span>
    </div>
  );
};
